import AddressUpdate from "@/models/address/AddressUpdate";
import AddressBilling from "@/models/address/AddressBilling";

export default class AddressBillingUpdate extends AddressUpdate {

	public emailBills!: boolean;

	protected initializeWithDetailModelData(detailModel: AddressBilling): void {
		super.initializeWithDetailModelData(detailModel);
		this.emailBills = detailModel.emailBills;
	}

}
